module.exports = __webpack_public_path__ + "img/playbutton8.36940b87.png";